<template>
  <div class="CYTdetail">
    <div id="aboutCYTop"></div>
    <BannerSwiper :bannerData="aboutCYBannerList" />
    <div class="CYT-detail-info">
      <div class="article-content">
        <div class="article">
          <div class="detail-dec">
            <div
              class="html-show"
              ref="htmlShow"
              v-html="
                lan ? CYTdetailInfo.contentEn : CYTdetailInfo.contentCn
              "
            ></div>
            
          </div>
          <div class="share-box" v-if="!isIndex">
        <ShareQr
          :showHomeStay="false"
          :showExhibitionInfo="false"
          :showLodg="false"
        />
      </div>
        </div>
        <div id="keySpace"></div>
      </div>
      <div class="grey-line"></div>
      <div class="show-act-box">
        <div class="content-title">
          <div class="title-left">
            {{ lan ? "Characteristic Space" : "特色空间" }}
          </div>
        </div>
        <!-- 特色空间部分 -->
        <div class="act-list">
          <ExhibitionBox
            :showData="item"
            :showType="0"
            :showIndex="index"
            v-for="(item, index) in actList"
            :key="item.id"
            @changeData="onDataChange"
            @showMobileDialog="showMobileDialog"
          />
        </div>
        <div id="architecture"></div>
      </div>
      <div class="grey-line"></div>

      <div class="show-act-box">
        <div class="content-title">
          <div class="title-left">
            {{ lan ? "On Architecture" : "关于建筑" }}
          </div>
        </div>
        <!-- 关于建筑部分 -->
        <div class="act-list">
          <ExhibitionBox
            :showData="item"
            :showType="1"
            :showIndex="index"
            v-for="(item, index) in architecture"
            :key="index"
            @changeData="onDataChange"
            @showMobileDialog="showMobileDialog"
          />
        </div>
      </div>
     
    </div>
    <el-dialog
      v-if="!isIndex && dialogVisible"
      :visible.sync="dialogVisible"
      :show-close="false"
      :lock-scroll="true"
      width="70%"
      :modal-append-to-body="false"
      :close-on-click-modal="true"
    >
      <ShowActBox
        @closePop="closePop"
        :showType="currentShowType"
        :showData="currentShowType === 1 ? architecture : actList"
        :showIndex="currentShowIndex"
      />
    </el-dialog>

    <!-- 移动端也需要相应修改 -->
    <el-dialog
      v-if="isIndex && (dialogVisible || dialogKeySpaceVisible)"
      :visible.sync="mobileDialogVisible"
      :show-close="false"
      :lock-scroll="true"
      :close-on-click-modal="true"
      :modal-append-to-body="false"
      width="100%"
      :key="`mobile-dialog-${currentShowIndex}`"
    >
      <WapActBox
        @closePop="closePop"
        :showType="currentShowType"
        :showData="currentShowType === 1 ? architecture : actList"
        :showIndex="currentShowIndex"
      />
    </el-dialog>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import ShareQr from "../components/shareQr.vue";
import ShowActBox from "../components/showActBox";
import WapActBox from "../components/wapActBox";
import ExhibitionBox from "../components/exhibitionBox";
import BannerSwiper from "../components/bannerSwiper.vue";

export default {
  name: "CYTdetail",
  components: {
    ShareQr,
    ShowActBox,
    ExhibitionBox,
    BannerSwiper,
    WapActBox,
  },
  data() {
    return {
      isIndex: false,
      content: "",
      pageIndex: 1,
      aboutCYBannerList: [
        {
          id: 1,
          img: require("@/assets/aboutCYT1.jpg"),
        },
        {
          id: 2,
          img: require("@/assets/aboutCYT2.jpg"),
        },
      ],
      actList: [
        {
          id: 1,
          title: "藏书楼",
          titleEn: "The Library",
          info: "藏书楼是春阳台的文化高地，设计师用人字形大阶梯将整个空间划分为上下两层。首层大厅陈列全套文渊阁影印版《四库全书》及一册四库真本，后者为文澜阁旧藏，弥足珍贵。两层书楼及错落其间的回廊里，开架陈列着超三万册图书，以中国传统文化为特色，经史子集皆备，古今版本俱有，兼收西方经典。崇宁万寿大藏经本、宋版书页、中世纪羊皮纸手抄本、欧洲“摇篮本”、海山仙馆丛帖及名家字画点缀于木色纹理的壁间，营造出一个书山有径书香氤氲的世界。",
          infoEn:
            "The Library is the cultural pinnacle of ChunYangTai. The designer used the shape of the Chinese character “人 (people)” to design the grand staircase and divide the space into two levels. The first-floor hall displays one original volume of Siku Quanshu (Complete Library in Four Sections), a precious antique of Wenlan Ge (or the Belvedere of Literary Profundity), as well as a photocopy set of the complete collection of Wenyuan Ge's Siku Quanshu. This two-story library, filled with winding corridors, showcases over 30,000 books, featuring classics — ancient and modern, East and West — of history, philosophy, and literature. Adorning the wooden walls are treasured cultural relics ranging from the Chongning Wanshou Tripitaka, the Sea-Hill House Series, pages of books from the Song Dynasty, parchments from medieval manuscripts, European incunabula, and calligraphy scrolls and paintings by famous artists. In this ocean of books, one can dive into the ocean of knowledge and literature.The library has a rare book room dedicated to the collection and study of rare ancient books. The room is designed in the Ming Dynasty style for literati. The precious books lining the room’s shelves, alongside the natural beauty of lotus ponds as seen through the room’s floor-to-ceiling windows, form an elegant and serene respite inside ChunYangTai. ",
          imageUrl: require("../../assets/architecture1.jpg"),
        },
        {
          id: 2,
          title: "塱上荷园",
          titleEn: "Rooftop Lotus Ponds",
          info: "坐落于天然荷塘中的春阳台，其屋顶精心设计了二十五个荷塘，栽种了荷花、莲花及其它水生植物。以塱头古村梳式街巷为灵感设计的步道，蜿蜒曲折，通达四方。漫步其上，宛如画卷般的美景尽收眼底，屋顶荷园与古村荷塘共同构成立体荷塘，建筑与环境和谐共生。",
          infoEn:
            "ChunYangTai, situated in the middle of a natural lotus pond, has a meticulously-designed rooftop that features over 25 miniature ponds planted with lotuses and other aquatic plants. The winding walkways are inspired by the comb-shaped streets and alleyways in Langtou Ancient Village. Strolling on the rooftop, one can easily take in beautiful views reminiscent of a painting. These rooftop lotus ponds, together with the village’s natural lotus ponds, create a multi-dimensional lotus pond landscape in which architecture and the environment harmoniously co-exist.",
          imageUrl: require("../../assets/architecture2.jpg"),
        },
        {
          id: 3,
          title: "剧场",
          titleEn: "Theater",
          info: "春阳台剧场坐落于村落古榕树之侧，这座充满韵味且功能丰富的双向观演剧场，传统经典粤剧、富有塱头民俗特色的演出、精彩纷呈的文化讲座都在此呈现。您可以在此欣赏各类精彩演出，还可漫步至荷塘环绕的双向看台，尽享休憩的美好时光。当您在观众席落座，静候舞台背景门缓缓展开，一幅如诗的现代乡村风景画便映入您的眼帘，这是春阳台为每位来客献上的自然画作，看山是山，看山不是山，看山还是山。",
          infoEn:
            "The ChunYangTai theater is located beside the village’s banyan tree. This charming and versatile double-sided stage can stage a variety of shows, from modern artistic performances to melodious Cantonese opera to Langtou folk art performances. Beyond enjoying spectacular shows, visitors can also enjoy relaxing strolls by the lotus pond surrounding the theater. When you sit in the front row and patiently await the stage backdrop to slowly unfold, a beautiful contemporary rural landscape painting comes into view. Nature’s beauty is ChunYangTai’s gift to every guest. This is inspired by the Chinese Zen proverb: First you see there is a mountain; then there is no mountain; then there is — charting one’s path to enlightenment and understanding.",
          imageUrl: require("../../assets/architecture3.jpg"),
        },
      ],
      architecture: [
        {
          id: 1,
          imageUrl: require("@/assets/OnArchitecture1.jpg"),
          title: "聚落式格局",
          titleEn: "Building Units Layout",
          info: "春阳台采用了与古村相呼应的聚落式格局，将展览、阅读、观演、研学、餐饮等功能分散布置在十座单体建筑中。其中七座单体建筑间以弧形的楼相串连，围合出尺度宜人的街巷与庭院，并消解了大体量建筑对古村环境的压迫感，呈现出一种诗意的融合。",
          infoEn:
            "Establishing connections with the scale and layout of the ancient village, the programs of the complex – exhibition spaces, library, theater, research studios, and café – are dispersed into ten individual small building units. Seven of these building units, connected by arc structures, together form alleys and courtyards of a delightful scale and dispel the sense of formidability posed by the massive building complex to the environment of the ancient village, presenting a poetic fusion.",
        },
        {
          id: 2,
          imageUrl: require("@/assets/OnArchitecture2.jpg"),
          title: "月牙窗",
          titleEn: "Crescent Windows",
          info: "作为对“龙船脊”以及“月梁”等岭南建筑元素的当代演绎，建筑立面上的月牙形开窗既为建筑内部空间带来更加微妙柔和的采光，又能成为透视周边乡野美景的弧形画框，是春阳台标志性的建筑符号。",
          infoEn:
            "As a contemporary interpretation of traditional Lingnan architectural elements such as “Dragon boat ridge” and “Moon beam”, the crescent windows bring not only subtle and soft lighting into the interior spaces but also serve as an arc-shaped frame for observing the surroundings. It has become the iconic architectural symbol of ChunYangTai.",
        },
        {
          id: 3,
          imageUrl: require("@/assets/OnArchitecture3.jpg"),
          title: "弧形“楼”",
          titleEn: "Curved Towers",
          info: "单体建筑通过弧形的“楼”相串联，同时也围合出尺度怡人的街巷与庭院。",
          infoEn:
            "Building units are connected by “towers” with curvilinear brick walls and form alleys and courtyards of intimate sizes in between.",
        },
        {
          id: 4,
          imageUrl: require("@/assets/OnArchitecture4.jpg"),
          title: "立体荷塘",
          titleEn: "Multi-level Lotus Pond",
          info: "建筑屋面设置了二十五组不同尺寸的种植池，其中茂盛的水生植物既是野趣的景观，也降低了建筑能耗。架空步道蜿蜒于屋面，从这里望去，种植池与下沉水院、周边的天然荷塘相互呼应，使春阳台成为一座融入环境、高低错落的“立体荷塘”。",
          infoEn:
            'We have placed nearly 30 groups of planted water ponds of different sizes on the roofs of buildings. The lush aquatic plants in the ponds not only form a natural landscape but also reduce the energy consumption of the buildings. The roof ponds, connected by elevated walkways, along with the natural ponds in the surrounding areas and the sunken courtyards, make ChunYangTai a "multi-level lotus pond system" that blends into nature.',
        },
        {
          id: 5,
          imageUrl: require("@/assets/OnArchitecture5.jpg"),
          title: "双向剧场及看台",
          titleEn: "Double-sided Theater",
          info: "剧场的舞台背面设有一整扇可以自动开合的门。每当门徐徐打开，观众便可从剧场内看到对面荷塘中的双向看台，游客端坐其中，或漫步周围，共同构成人景共生的美妙画面。",
          infoEn:
            "There is a door in the back of the stage of the theater that can open and close automatically. When the door opens slowly, the audience inside the theater can see the double-sided stand in the lotus pond on the opposite side of the theater. Visitors sitting in the stand or wandering around the area thus become part of the scenery.",
        },
        {
          id: 6,
          imageUrl: require("@/assets/OnArchitecture6.jpg"),
          title: "传统材质与技艺创新",
          titleEn:
            "Innovations of Traditional Materials and Building Techniques",
          info: "在选材上，通过对塱头传统乡土建筑进行的类型学调研与分析，春阳台确定了最具地域代表性的核心材料：红瓦和青砖，并与木模清水混凝土结合。在建设过程中，建筑材料部分参照传统工艺规范，如红瓦砌法源自当地的“双坡叠砌”，青砖则采用“全顺砌筑”。现代材料则采用了高性能混凝土和节能玻璃等，但都经过了与传统环境的适配性测试。其次在建造技艺方面，春阳台在尊重传统智慧的基础上，混凝土采用窄条木板做浇筑模板，以模拟手工砖墙的肌理效果。通风巷道的设计遵循了岭南民居“冷巷”的原理，并将传统砌筑巷道优化为混凝土框架与镂空瓦墙的复合构造。",
          infoEn:
            "Typological study of traditional rural architecture in Langtou was first conducted to identify the most regionally representative materials, namely, red clay tiles and grey bricks, which were then integrated with board-formed concrete in ChunYangTai. During construction, traditional materials drew reference from local craftsmanship standards: red tiles were laid using the local double-slope stacking method, and the grey bricks employed the standard flush bonding technique. Modern materials such as high-performance concrete and energy-efficient glass were also used, but only after compatibility testing to ensure harmonious integration with the historic environment. For instance, the façade's concrete mix was selected after multiple rounds of material testing to meet structural requirements while achieving a surface texture that engages in a respectful visual dialogue with traditional materials. The steel structural components, prefabricated off-site and assembled on location, improved construction precision and minimised disruption to the historic village environment.In terms of construction techniques, the new architecture introduces innovations grounded in respect for traditional craftsmanship. For example, narrow timber planks were used as concrete formwork to simulate the texture of hand-laid brick walls. The green roof system integrates modern technologies such as automated irrigation and waterproof root barriers. The ventilation alleyways were designed in accordance with the 'cold alley' thermal principle found in traditional Lingnan dwellings, and the traditional brick passageways were adapted into a composite structure of concrete framing and perforated brick walls for improved performance and durability.",
        },
      ],
      lan: this.$store.state.isEn,
      dialogVisible: false,
      dialogKeySpaceVisible: false,
      screenWidth: 0,
      currentShowType: 0, // 0 for actList, 1 for architecture
      currentShowIndex: 0, // 添加当前显示索引
      mobileDialogVisible: false,
      CYTdetailInfo: {},
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
    dialogVisible(newVal) {
      if (this.isIndex) {
        this.mobileDialogVisible = newVal;
      }
    },
    dialogKeySpaceVisible(newVal) {
      if (this.isIndex) {
        this.mobileDialogVisible = newVal;
      }
    },
    // 添加反向监听，确保关闭时状态正确同步
    mobileDialogVisible(newVal) {
      if (!newVal) {
        // 当移动端弹窗关闭时，同时关闭相关状态
        this.dialogVisible = false;
        this.dialogKeySpaceVisible = false;
      }
    },
  },
  created() {
    // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', this.updateFontSizeClass);
    this.$root.$off("openDialog", this.handleOpenDialog);
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
  },
  mounted() {
    localStorage.removeItem("path");
    localStorage.removeItem("columnId");
    this.init();
    this.updateFontSizeClass();
    window.addEventListener('resize', this.updateFontSizeClass);

    // 处理页面加载时的滚动定位
    this.handleInitialScroll();
    // 监听来自 exhibitionBox 的弹窗打开事件
    this.$root.$on("openDialog", this.handleOpenDialog);
  },
  methods: {
    handleOpenDialog(type, index) {
      this.currentShowType = type;
      this.currentShowIndex = index;

      this.$nextTick(() => {
        // 根据类型决定使用哪个弹窗
        if (type === 0) {
          // 特色空间
          if (this.isIndex) {
            this.dialogKeySpaceVisible = true;
            this.mobileDialogVisible = true; // 同时设置移动端状态
          } else {
            this.dialogVisible = true;
          }
        } else {
          // 建筑部分
          if (this.isIndex) {
            this.dialogVisible = true;
            this.mobileDialogVisible = true; // 同时设置移动端状态
          } else {
            this.dialogVisible = true;
          }
        }
      });
    },
    handleInitialScroll() {
      // 只有在页面初次加载且有hash时才滚动
      const hash = this.$route.hash;
      const index = this.$route.query.index;

      // 如果没有hash参数，不执行滚动
      if (!hash) return;

      // 确保在 DOM 更新后再执行滚动
      this.$nextTick(() => {
        // 延迟执行，确保页面内容加载完成
        setTimeout(() => {
          if (hash === "#keySpace") {
            const element = document.getElementById("keySpace");
            if (element) {
              element.scrollIntoView({ behavior: "smooth" });
              // 如果URL中包含索引参数，则打开对应弹窗
              if (index !== undefined) {
                this.currentShowType = 0;
                this.currentShowIndex = parseInt(index);
                this.$nextTick(() => {
                  // 特色空间使用 dialogVisible 并通过 dialogKeySpaceVisible 控制移动端
                  if (this.isIndex) {
                    this.dialogKeySpaceVisible = true;
                  } else {
                    this.dialogVisible = true;
                  }
                });
              }
            }
          } else if (hash === "#architecture") {
            const element = document.getElementById("architecture");
            if (element) {
              element.scrollIntoView({ behavior: "smooth" });
              // 如果URL中包含索引参数，则打开对应弹窗
              if (index !== undefined) {
                this.currentShowType = 1;
                this.currentShowIndex = parseInt(index);
                this.$nextTick(() => {
                  // 建筑部分使用 dialogVisible
                  this.dialogVisible = true;
                });
              }
            }
          }
        }, 300); // 增加延迟时间确保内容加载完成
      });
    },
    // 移动端弹窗显示方法
    showMobileDialog(type, index) {
      this.currentShowType = type;
      this.currentShowIndex = index;

      this.$nextTick(() => {
        if (type === 0) {
          this.dialogKeySpaceVisible = true;
        } else {
          this.dialogVisible = true;
        }
        // 确保移动端状态也被设置
        this.mobileDialogVisible = true;
      });
    },
    updateFontSizeClass() {
      const screenWidth = window.innerWidth;
      const htmlShowElement = this.$refs.htmlShow;
      
      if (!htmlShowElement) return;
      
      // 清除现有样式
      htmlShowElement.style.fontSize = '';
      const elements = htmlShowElement.querySelectorAll('*');
      elements.forEach(el => {
        el.style.fontSize = '';
        el.style.lineHeight = '';
      });
      
      // 根据屏幕宽度设置字体大小
      if (screenWidth <= 960) {
        // 小屏幕
        htmlShowElement.style.fontSize = '14px';
        const paragraphs = htmlShowElement.querySelectorAll('p');
        paragraphs.forEach(p => {
          p.style.fontSize = '14px';
          p.style.lineHeight = '24px';
          p.style.marginBottom = '12px';
        });
        
        const headings = htmlShowElement.querySelectorAll('h1, h2, h3, h4, h5, h6');
        headings.forEach((h, index) => {
          switch(h.tagName) {
            case 'H1': h.style.fontSize = '24px'; break;
            case 'H2': h.style.fontSize = '20px'; break;
            case 'H3': h.style.fontSize = '18px'; break;
            case 'H4': h.style.fontSize = '16px'; break;
            case 'H5': h.style.fontSize = '14px'; break;
            case 'H6': h.style.fontSize = '12px'; break;
          }
          h.style.margin = '16px 0';
          h.style.fontWeight = 'bold';
        });
        
        const images = htmlShowElement.querySelectorAll('img');
        images.forEach(img => {
          img.style.maxWidth = '100%';
          img.style.height = 'auto';
          img.style.marginBottom = '0px';
        });
      } else if (screenWidth <= 1440) {
        // 中等屏幕
        htmlShowElement.style.fontSize = '16px';
        const paragraphs = htmlShowElement.querySelectorAll('p');
        paragraphs.forEach(p => {
          p.style.fontSize = '16px';
          p.style.lineHeight = '28px';
          p.style.marginBottom = '14px';
        });
        
        const headings = htmlShowElement.querySelectorAll('h1, h2, h3, h4, h5, h6');
        headings.forEach((h, index) => {
          switch(h.tagName) {
            case 'H1': h.style.fontSize = '28px'; break;
            case 'H2': h.style.fontSize = '24px'; break;
            case 'H3': h.style.fontSize = '20px'; break;
            case 'H4': h.style.fontSize = '18px'; break;
            case 'H5': h.style.fontSize = '16px'; break;
            case 'H6': h.style.fontSize = '14px'; break;
          }
          h.style.margin = '16px 0';
          h.style.fontWeight = 'bold';
        });
        
        const images = htmlShowElement.querySelectorAll('img');
        images.forEach(img => {
          img.style.maxWidth = '100%';
          img.style.height = 'auto';
          img.style.marginBottom = '18px';
        });
      } else {
        // 大屏幕
        htmlShowElement.style.fontSize = '18px';
        const paragraphs = htmlShowElement.querySelectorAll('p');
        paragraphs.forEach(p => {
          p.style.fontSize = '18px';
          p.style.lineHeight = '32px';
          p.style.marginBottom = '16px';
        });
        
        const headings = htmlShowElement.querySelectorAll('h1, h2, h3, h4, h5, h6');
        headings.forEach((h, index) => {
          switch(h.tagName) {
            case 'H1': h.style.fontSize = '32px'; break;
            case 'H2': h.style.fontSize = '28px'; break;
            case 'H3': h.style.fontSize = '24px'; break;
            case 'H4': h.style.fontSize = '20px'; break;
            case 'H5': h.style.fontSize = '18px'; break;
            case 'H6': h.style.fontSize = '16px'; break;
          }
          h.style.margin = '16px 0';
          h.style.fontWeight = 'bold';
        });
        
        const images = htmlShowElement.querySelectorAll('img');
        images.forEach(img => {
          img.style.maxWidth = '100%';
          img.style.height = 'auto';
          img.style.marginBottom = '26px';
        });
      }
    },
    handleMediaQueryChange(event) {
      if (event.matches) {
        this.isIndex = false;
      } else {
        this.isIndex = true;
      }
      this.updateFontSizeClass();
    },
    async init() {
      await this.$api.get(
        "/advert/list",
        { current: 1, pageSize: 10, advertFlagName: "aboutCY_banner" },
        (r) => {
          const { data, code } = r;
          if (code == 0) {
            if (data && data.length > 0) {
              data.forEach((el) => {
                el.img = (el.image && JSON.parse(el.image)[0].src) || "";
              });
            }
            this.aboutCYBannerList = JSON.parse(JSON.stringify(data));
          }
        }
      );
      this.$api.get("/summary/detail", {}, (r) => {
        const { data, code } = r;
        if (code == 0) {
          this.CYTdetailInfo = data;
          // DOM 更新后调整字体大小
          this.$nextTick(() => {
            this.updateFontSizeClass();
          });
        }
      });
    },
    onDataChange(data, index) {
      // 设置当前类型和索引
      this.currentShowType = data;
      this.currentShowIndex = index;

      // 延迟显示弹窗，确保数据已更新
      this.$nextTick(() => {
        // 根据类型决定使用哪个弹窗
        if (data === 0) {
          // 特色空间
          if (this.isIndex) {
            this.dialogKeySpaceVisible = true;
            this.mobileDialogVisible = true; // 同时设置移动端状态
          } else {
            this.dialogVisible = true;
          }
        } else {
          // 建筑部分
          if (this.isIndex) {
            this.dialogVisible = true;
            this.mobileDialogVisible = true; // 同时设置移动端状态
          } else {
            this.dialogVisible = true;
          }
        }
      });
    },
    closePop() {
      this.dialogVisible = false;
      this.dialogKeySpaceVisible = false;
      this.mobileDialogVisible = false;
    },
  },
};
</script>
<style scoped>
.CYTdetail {
  margin-top: 94px;
}
.CYT-detail-info {
  position: relative;
  width: 1440px;
  height: 100%;
  margin: 70px auto 120px;
  background-color: #fff;
}
.article-content {
  width: 100%;
  margin: 0 auto;
}
.article {
  display: flex;
  width: 98%;
}
.share-box {
margin: 20px 50px;
}
.CYT-detail-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.detail-sub-title {
  margin-bottom: 32px;
  font-family: SourceHanSansCN-Bold;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  line-height: 32px;
  font-weight: 700;
}
.detail-dec {
  margin-bottom: 32px;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  line-height: 32px;
  font-weight: 400;
}
.grey-line {
  margin-top: 70px;
  width: 100%;
  height: 1px;
  background: #d8d8d8;
}
.show-act-box {
  width: 100%;
  margin: 60px auto 0px;
}
.act-list {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.content-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.CYT-sub-title {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  font-weight: 400;
  margin: 10px 0;
}
.title-left {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.title-right {
  position: relative;
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #98989f;
  text-align: left;
  font-weight: 400;
  padding-right: 15px;
  cursor: pointer;
}
.sub-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 34px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  margin-top: 10px;
}
.title-right::after {
  content: "";
  position: absolute;
  top: 55%;
  right: 0px;
  width: 8px;
  height: 8px;
  border-top: 2px solid #666666;
  border-right: 2px solid #666666;
  -webkit-transform: translateY(-45%) rotate(45deg);
  transform: translateY(-45%) rotate(45deg);
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #666666;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #666666;
}

/* 居中弹窗样式 */
::v-deep .el-dialog {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important;
}

::v-deep .el-dialog__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 1450px) {
  .CYTdetail {
    overflow: hidden;
    margin-top: 80px;
  }
  .CYT-detail-info {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 50px auto 30px;
    background-color: #fff;
  }
  .article {
  display: flex;
  width: 98%;
}
.share-box {
margin: 20px 50px;
}
  .CYT-detail-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 32px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
  }
  .detail-sub-title {
    margin-bottom: 32px;
    font-family: SourceHanSansCN-Bold;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    line-height: 32px;
    font-weight: 700;
  }
  .detail-dec {
    margin-bottom: 32px;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    line-height: 32px;
    font-weight: 400;
  }
  .title-left {
    font-family: SourceHanSansCN-Bold;
    font-size: 26px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
  }
  .title-right {
    position: relative;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    color: #98989f;
    text-align: left;
    font-weight: 400;
    padding-right: 15px;
    cursor: pointer;
  }
  .sub-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 23px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
    margin-top: 10px;
  }
  .grey-line {
    width: 90%;
    height: 1px;
    margin: 70px auto 0;
    background: #d8d8d8;
  }
  .CYTdetail .act-list {
    width: 98%;
    height: auto;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  .content-title {
    max-width: 1440px;
    width: 90%;
    margin-left: 30px;
  }
  .article-content {
    width: 95%;
    margin: 0 auto;
  }
  .show-act-box {
    width: 95%;
    margin: 60px auto 0px;
  }
}
@media (max-width: 960px) {
  .CYTdetail {
    margin-top: 80px;
  }
  .CYT-detail-info {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 30px auto 30px;
    background-color: #fff;
  }
  .article {
    width: 100%;
    margin: 40px auto;
  }
  .CYT-detail-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 26px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
  }
  .detail-sub-title {
    margin-bottom: 32px;
    font-family: SourceHanSansCN-Bold;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    line-height: 32px;
    font-weight: 700;
  }
  .article-content {
    width: 90%;
    margin: 0 auto;
  }
  .detail-dec {
    margin-bottom: 32px;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    line-height: 32px;
    font-weight: 400;
  }
  .grey-line {
    width: 90%;
    height: 1px;
    margin: 50px auto 0;
    background: #d8d8d8;
  }
  .CYTdetail .act-list {
    width: 95%;
    height: auto;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
  }
  .content-title {
    width: 100%;
    margin-left: 30px;
  }
  .show-act-box {
    width: 100%;
    margin: 50px auto 0px;
  }
  .title-left {
    font-size: 26px;
    margin-left: 4%;
  }

  /* 移动端居中弹窗样式 */
  ::v-deep .el-dialog {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin: 0 !important;
    width: 95% !important;
  }

  ::v-deep .el-dialog__body {
    padding: 0 0 20px;
    height: 80vh;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
}
@media (max-width: 640px) {
  .CYT-detail-title {
    font-size: 22px;
  }
  .title-left {
    font-size: 22px;
    margin-left: 0%;
  }
  .CYT-sub-title {
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 12px;
  }
  .detail-sub-title {
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 12px;
  }
  .detail-dec {
    font-size: 13px;
    line-height: 24px;
    margin-bottom: 12px;
  }
  .article {
    margin: 10px auto;
  }
  .grey-line {
    width: 90%;
    height: 1px;
    margin: 30px auto 0;
    background: #d8d8d8;
  }
  .show-act-box {
    width: 100%;
    margin: 20px auto 0px;
  }
}
</style>